const capitalizeWords = (value) => {
  if (value === null || value === undefined) return "";

  return value
    .toString()
    .trim()
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

const normalizeAddressParts = (parts = []) =>
  parts.map(capitalizeWords).filter((part) => Boolean(part) && part !== "N/A");

export const formatSchoolAddress = (school) => {
  if (!school) {
    return "N/A";
  }

  if (typeof school === "string") {
    const normalized = capitalizeWords(school);
    return normalized || "N/A";
  }

  const {
    school_name: schoolName,
    city,
    state,
    country,
    pincode,
    address,
  } = school;

  let formattedParts = normalizeAddressParts([
    schoolName,
    city,
    state,
    country,
  ]);

  if (formattedParts.length === 0 && address) {
    const normalizedAddress = capitalizeWords(address);
    if (normalizedAddress) {
      formattedParts = [normalizedAddress];
    }
  }

  if (pincode) {
    formattedParts.push(pincode.toString().trim());
  }

  if (formattedParts.length === 0) {
    return "N/A";
  }

  return formattedParts.join(", ");
};

export default formatSchoolAddress;
